import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const fetchTaxCreditList = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_TAX_CREDIT}?page=1&limit=100&clientId=${ID}`
        : `${ROUTES.GET_TAX_CREDIT}?page=1&limit=100`,
  });
  return res;
};
const saveTaxCredit = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_TAX_CREDIT}?clientId=${ID}`
        : `${ROUTES.CREATE_TAX_CREDIT}`,
    body,
  });
  return res;
};
const deleteTaxCredit = async (id) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.deletee({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.DELETE_TAX_CREDIT}?id=${id}&clientId=${ID}`
        : `${ROUTES.DELETE_TAX_CREDIT}?id=${id}`,
  });
  return res;
};

const updateTaxCredit = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.putWithoutId({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_TAX_CREDIT}?clientId=${ID}`
        : `${ROUTES.CREATE_TAX_CREDIT}`,
    body,
  });
  return res;
};
const fetchTaxInflationDetails = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_TAX_INFLATION}?clientId=${ID}`
        : ROUTES.GET_TAX_INFLATION,
  });
  return res;
};
const saveTaxInflationDetails = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_TAX_INFLATION}?clientId=${ID}`
        : `${ROUTES.CREATE_TAX_INFLATION}`,
    body,
  });
  return res;
};
const updateTaxInflationDetails = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_TAX_INFLATION}?clientId=${ID}`
        : `${ROUTES.CREATE_TAX_INFLATION}`,
    body,
  });
  return res;
};

const fetchCarryForward = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD}?page=1&limit=100&clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD}?page=1&limit=100`,
  });
  return res;
};
const createCarryForward = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD}?clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD}`,
    body,
  });
  return res;
};
const updateCarryForward = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD}?clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD}`,
    body,
  });
  return res;
};
const deleteCarryForwad = async (id) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.deletee({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD}?id=${id}&clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD}?id=${id}`,
  });
  return res;
};

const fetchCarryForwardTax = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD_Tax}?page=1&limit=100&clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD_Tax}?page=1&limit=100`,
  });
  return res;
};
const createCarryForwardTax = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");

  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD_Tax}?clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD_Tax}`,
    body,
  });
  return res;
};
const updateCarryForwardTax = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD_Tax}?clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD_Tax}`,
    body,
  });
  return res;
};
const deleteCarryForwadTax = async (id) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.deletee({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CARRY_FORWARD_Tax}?id=${id}&clientId=${ID}`
        : `${ROUTES.CREATE_CARRY_FORWARD_Tax}?id=${id}`,
  });
  return res;
};
const getRatesofReturn = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_RATE_OF_RETURN}?clientId=${ID}`
        : `${ROUTES.CREATE_RATE_OF_RETURN}`,
  });
  return res;
};
const getUserDefinedDetails = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.USER_DEFINED_DETAILS}?clientId=${ID}`
        : `${ROUTES.USER_DEFINED_DETAILS}`,
  });
  return res;
};

const createRatesofReturn = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_RATE_OF_RETURN}?clientId=${ID}`
        : `${ROUTES.CREATE_RATE_OF_RETURN}`,
    body,
  });
  return res;
};
const updateRatesofReturn = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_RATE_OF_RETURN}?clientId=${ID}`
        : `${ROUTES.CREATE_RATE_OF_RETURN}`,
    body,
  });
  return res;
};
const getUserDefined = async (page) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.USER_DEFINED}?page=${page}&limit=10&clientId=${ID}`
        : `${ROUTES.USER_DEFINED}?page=${page}&limit=10`,
  });
  return res;
};

const createUserDefined = async (body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.USER_DEFINED}?clientId=${ID}`
        : `${ROUTES.USER_DEFINED}`,
    body,
  });
  return res;
};

const updateUserDefined = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.USER_DEFINED}`,
    body,
  });
  return res;
};
const deleteUserDefined = async (id) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.deletee({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.USER_DEFINED}?id=${id}&clientId=${ID}`
        : `${ROUTES.USER_DEFINED}?id=${id}`,
  });
  return res;
};

const TAX_AND_INFLATION_API = {
  fetchTaxCreditList,
  saveTaxCredit,
  fetchTaxInflationDetails,
  saveTaxInflationDetails,
  updateTaxInflationDetails,
  updateTaxCredit,
  deleteTaxCredit,
  fetchCarryForward,
  createCarryForward,
  updateCarryForward,
  deleteCarryForwad,
  fetchCarryForwardTax,
  createCarryForwardTax,
  updateCarryForwardTax,
  deleteCarryForwadTax,
  createRatesofReturn,
  getRatesofReturn,
  getUserDefinedDetails,
  updateRatesofReturn,
  createUserDefined,
  getUserDefined,
  updateUserDefined,
  deleteUserDefined,
};
export default TAX_AND_INFLATION_API;
